import db from "../firebase/init";
export const getUserNameOffId = {
  methods: {
    fetchName(param) {
      const name = db
        .collection("users")
        .doc(`${param}`)
        .get()
        .then((querySnapShot) => {
          return querySnapShot.data().fullname;
        })
        .catch((err) => console.log(err));
      return name;
    },
  },
};
